import { Field, Post as Props } from '@/types';
import Fields, { resolveFields } from '@/components/frontend/Fields';
import ContentSection from '@/components/frontend/ContentSection';
import ArticleLayout, {
  FieldsLayout,
} from '@/components/frontend/ArticleLayout';
import Hero from '@/components/frontend/Hero';
import { splitFields } from './Page';

const ensureContentOrder = (contentFields: Field[]) =>
  contentFields.sort(({ __name: aName }) => {
    if (aName === 'acf/todo-list') {
      return -1;
    }
    return 0;
  });

const GuidePage = ({
  fields,
  post_title: title,
  post_excerpt: leadText,
  featured_image,
}: Props) => {
  const [hero, contentFields] = resolveFields(fields);
  const { basicFields, sectionFields } = splitFields(contentFields);

  const heroProps = hero
    ? {
        title: hero.heading || title,
        leadText: hero.text || leadText,
        image: hero.image || featured_image,
      }
    : { title, leadText, image: featured_image };

  return (
    <ArticleLayout bg="white" flex="1 1 auto">
      <Hero {...heroProps} variant="landing" />
      <FieldsLayout>
        {basicFields.length ? (
          <ContentSection>
            <Fields fields={ensureContentOrder(basicFields)} />
          </ContentSection>
        ) : null}
        {sectionFields.length ? (
          <FieldsLayout sectionsLayout>
            <Fields fields={sectionFields} />
          </FieldsLayout>
        ) : null}
      </FieldsLayout>
    </ArticleLayout>
  );
};

export default GuidePage;
